import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { getManagers } from '../../api/managerService';

const DirectorateImage = ({ src, name }) => {
  const [hasError, setHasError] = useState(false);
  const initials = (name || '')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join('')
    .toLocaleUpperCase('tr-TR');

  if (!src || hasError) {
    return <span className="directorates-image-fallback">{initials || 'İB'}</span>;
  }

  return <img src={src} alt={name || 'Müdür'} onError={() => setHasError(true)} />;
};

export default function Directorates() {
  const [directorates, setDirectorates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDirectorates = async () => {
      try {
        const response = await getManagers();
        console.log('Müdürler Listesi Response:', response);
        if (response.isSuccess && response.data) {
          setDirectorates(response.data);
        } else {
          setError(response.resultMessage || 'Müdürlük bilgileri yüklenirken bir hata oluştu.');
        }
        setLoading(false);
      } catch (err) {
        console.error('Müdürler Listesi Error:', err);
        setError('Müdürlük bilgileri yüklenirken bir hata oluştu.');
        setLoading(false);
      }
    };

    fetchDirectorates();
  }, []);

  if (loading) {
    return (
      <>
        <Helmet>
          <title>Yükleniyor... | İskenderun Belediyesi</title>
        </Helmet>
        <div className="directorates-page">
          <div className="container py-5">
            <div className="text-center">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Yükleniyor...</span>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <Helmet>
          <title>Hata | İskenderun Belediyesi</title>
        </Helmet>
        <div className="directorates-page">
          <div className="container py-5">
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>Müdürlerimiz | İskenderun Belediyesi</title>
        <meta name="description" content="İskenderun Belediyesi müdürlükleri ve yöneticileri hakkında detaylı bilgi." />
      </Helmet>
      <div className="directorates-page">
        <div className="container py-5">
          <h1 className="page-title">Müdürlüklerimiz</h1>
          <div className="directorates-boxes row">
            {directorates.map((director) => (
              <div className="col-12 col-md-6 col-lg-3" key={director.guid}>
                <div className="directorates-box">
                  <div className="directorates-box_media">
                    <DirectorateImage src={director.pictureUrl} name={director.name} />
                  </div>
                  <div className="directorates-box_content">
                    <div className="directorates-title">
                      <h2>{director.name}</h2>
                      <p>{director.positionName}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
